import React, { useCallback, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TaskTimeline from './TaskTimeline';
import NestedTasksTable from './NestedTaskTable';
export const ClaimState = _ref => {
  let {
    tasks,
    markTaskComplete,
    claimGroup
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const getActiveIndex = useCallback(() => {
    const inProgress = tasks.findIndex(task => task.status === 'in_progress');
    if (inProgress !== -1) return inProgress;
    const notStarted = tasks.findIndex(task => task.status === 'not_started');
    return notStarted !== -1 ? notStarted : tasks.length - 1;
  }, [tasks]);
  useEffect(() => {
    setSelectedIndex(getActiveIndex());
  }, [getActiveIndex]);
  const handleSelectTask = index => {
    setSelectedIndex(prev => prev === index ? null : index);
  };
  const activeIndex = getActiveIndex();
  const selectedTask = selectedIndex !== null ? tasks[selectedIndex] : null;
  const showWarning = selectedIndex !== null && selectedIndex < activeIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(TaskTimeline, {
    tasks: tasks,
    activeIndex: activeIndex,
    selectedIndex: selectedIndex,
    onSelectTask: handleSelectTask,
    t: t
  }))), showWarning && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning",
    role: "alert",
    style: {
      marginBottom: '1rem'
    }
  }, t('you_have_unfinished_previous_tasks')), selectedTask && /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(NestedTasksTable, {
    task: selectedTask,
    claimGroup: claimGroup,
    selectedIndex: selectedIndex,
    markTaskComplete: markTaskComplete,
    t: t
  }))));
};
export default ClaimState;